import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { groupBy } from 'lodash';
import { translate } from '../Services/translation';

export const boldSubstr = (baseString, _substr) => {
    const substr = decodeURIComponent(_substr).trim();
    if (!baseString) {
        return '';
    }
    return baseString.replace(new RegExp(substr, 'ig'), (match) => {
        return `<b>${match}</b>`
    });
}

const QuickSearchResult = ({ selectedItem, searchUrl, onClose, query, isHomeSearch = false, onlyProducts = false }) => {
    let category;
    let items = <></>;
    let [currentCutegory, setCurrentCutegory] = useState(null);
    const { 
        result,
        showResult        
    } = useSelector((state) => isHomeSearch ?  state.homeSearch : state.quickSearch);      

    return <div className="quick-search-result">
        {result && result.map((item, index) => {
            if (!(item.category != 'NoHit' && item.category != 'ShowAll' && item.category != category)) {
                return null;
            } else {
                const _data = (Object.entries(groupBy(result, ({ searchDisplayName }) => searchDisplayName))).filter(item => item[0] !== 'null').reverse();                
                const tabs = <>{_data.length ? _data.map(item => <li className="tabs-title" key={`li-${item[0]}`}>
                    <p onClick={() => setCurrentCutegory(item[0])}
                        dangerouslySetInnerHTML={{ __html: (currentCutegory === item[0] || (currentCutegory === null && item[0] === _data[0][0])) ? boldSubstr(item[0], item[0]) : item[0] }}>
                    </p></li>) : null}</>;
                const showTabs = () => _data && _data[0] && _data[0][0] && _data[0][0] !== 'undefined' ? (<ul className="tabs" data-active-collapse="true" data-tabs id="collapsing-tabs">
                    {tabs}
                </ul>) : null;
                const _panel = _data.map(elem => elem[1]);

                const panels = <>{_panel && _panel.length && _panel.map(_item =>
                    <div key={`panel-${_item[0].name}-${index}`} className={`tabs-panel ${currentCutegory === _item[0].searchDisplayName || (currentCutegory === null && _item[0].searchDisplayName === _panel[0][0].searchDisplayName) ? "is-active" : ""}`} id={_item[0].name}>
                        {_item.map(__item =>
                            <div className="product-row">
                                <div className='product-row__image'>
                                    {__item.imageSource ? <img src={__item.imageSource} /> : null}
                                </div>
                                <a className={`quick-search-result__link ${__item.url ? '' : 'quick-search-result__link--disabled'}`}
                                    href={__item.url}>
                                    <div dangerouslySetInnerHTML={{ __html: boldSubstr(__item.name, query) }}></div>
                                </a>
                            </div>)}
                        <a className={'quick-search-result__show-all button'}
                            href={searchUrl}>
                            <div>{(Object.entries(groupBy(result, ({ searchDisplayName }) => searchDisplayName))).find(item => item[0] === 'null')[1][0].name}</div>
                        </a>
                    </div>)}</>;
                items = (<>{showTabs()}
                    <div className="tabs-content" data-tabs-content="collapsing-tabs">
                        {panels}
                    </div></>)
            }
        })
        }
        {items}
        <i className="close" onClick={onClose}></i>
    </div>
}

export default QuickSearchResult;